import { useEffect, useState } from 'react';
import api from '@/lib/api';

// LIVE-SELLER-RECORDING-TEST-FLOW-1 · 기본 목록(최대 500개)에 없는 본인 상품도 검색어로 서버 조회.
export const useSellerProductSearch = (q, enabled = true) => {
  const [found, setFound] = useState([]);
  useEffect(() => {
    const term = (q || '').trim();
    if (!enabled || !term) { setFound([]); return undefined; }
    let cancelled = false;
    const t = setTimeout(() => {
      api.get('/seller/products', { params: { q: term, page: 1, limit: 100 } })
        .then((r) => { if (!cancelled) setFound(r.data?.items || []); })
        .catch(() => { if (!cancelled) setFound([]); });
    }, 300);
    return () => { cancelled = true; clearTimeout(t); };
  }, [q, enabled]);
  return found;
};

export const mergeProducts = (base, extra) => {
  if (!extra?.length) return base;
  const seen = new Set(base.map((p) => p.product_id));
  return [...base, ...extra.filter((p) => !seen.has(p.product_id))];
};
